export const getXpacks = ({ xpacks }) => xpacks.list.data.items;

export const getIsLoading = ({ xpacks }) => xpacks.list.isLoading;

export const getPaginationOptions = ({ xpacks }) =>
  xpacks.list.paginationOptions;

export const getXpacksCount = ({ xpacks }) => xpacks.list.data.count;

export const getSelectedSortOption = ({ xpacks }) =>
  xpacks.list.paginationOptions.ordering;

export const getIsAdding = ({ xpacks }) => xpacks.add.isLoading;

export const getIsDownloading = ({ xpacks }) => xpacks.download.isLoading;

export const getIsDeleting = ({ xpacks }) => xpacks.delete.isLoading;

export const getIsUpdating = ({ xpacks }) => xpacks.update.isLoading;

export const getOverrideAllXpackIntentsIsLoading = ({ xpacks }) =>
  xpacks.overrideAllXpackIntents.isLoading;

export const getDisableAllXpackIntentsIsLoading = ({ xpacks }) =>
  xpacks.disableAllXpackIntents.isLoading;
